import { ModelBase } from 'store/model-base';

export class NowPortOutChangeNotify extends ModelBase {
    public static storeName: string = 'nowPortOutChangeNotify';

    public notificationRefId: string;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowPortOutChangeNotify = super.create<NowPortOutChangeNotify>(initData);

        return super.create<T>(toReturn);
    }
}